<template>
  <main id="directions-wrap">
    <DirectionsTutorial v-if="showDirectionsTutorial"></DirectionsTutorial>
    <DirectionsMap ref="directionsMap" :routeData="routeData" :startOptions="destinationOptions['start']" :endOptions="destinationOptions['end']" :viaOptions="destinationOptions['via']" @selectedOnMap="destinationSelectedOnMap" :showRoadwork="showRoadwork" :showParking="showParking" :typeOfParking="typeOfParking"></DirectionsMap>

    <div id="directions-box" class="container-fluid white-box" v-show="!showRouteDetails">
      <RouteOverview :showRouteOverview="showRouteOverview" @editRoute="showRouteOverview = false;" v-show="showRouteOverview" @showRouteDetails="showRouteDetails = true;"></RouteOverview>

      <DirectionsInputFields v-show="!showRouteOverview" @switcharoo="switcharoo" :showViaPoint="showViaPoint" @toggleViaPoint="toggleViaPoint"></DirectionsInputFields>

      <RouteTypes :showRouteTypes="showRouteTypes" @routeTypeSelected="selectRouteType"></RouteTypes>

      <div id="route-differences-box" class="row" v-show="routeData.length > 1">
        <template v-for="(route,index) in routeData">
          <div class="route-difference-select" :class="{ blue: route.selected }" @click="setRouteAsActive(route.name)" tabindex="0">
            <span v-if="route.alternateRoute"> {{ route.name }} - Klik for information</span>
            <span v-else> {{ route.name }} </span>
          </div>
        </template>
      </div>
    </div>

    <RouteDetails :routeData="routeData" v-if="showRouteDetails"></RouteDetails>

    <DirectionsSearchBox ref="directionsSearchBox" v-show="showAddressSearch" :direction="direction" @addressDataReady="setDestination"></DirectionsSearchBox>

    <DirectionsBar :showRoadwork="showRoadwork" @toggleRoadwork="toggleRoadwork" :showParking="showParking" @toggleParking="toggleParking"></DirectionsBar>
  </main>
</template>

<script>
import DirectionsMap from '@/components/directions/DirectionsMap.vue'
import DirectionsInputFields from '@/components/directions/DirectionsInputFields.vue'
import RouteTypes from '@/components/directions/RouteTypes.vue'
import RouteOverview from '@/components/directions/RouteOverview.vue'
import DirectionsSearchBox from '@/components/directions/DirectionsSearchBox.vue'
import DirectionsBar from '@/components/directions/DirectionsBar.vue'
import RouteDetails from '@/components/directions/RouteDetails.vue'
import DataFunctions from '@/assets/DataFunctions.js'
import RoutePlanner from '@/assets/routePlanner/RoutePlanner.js'
import RoutePlannerTools from '@/assets/routePlanner/RoutePlannerTools.js'
import AWS from '@/assets/aws.js'
import { EventBus } from '@/main.js'
import DirectionsTutorial from '@/components/tutorials/DirectionsTutorial.vue'

export default {
  data() {
    return {
      showAddressSearch: false,
      showViaPoint: false,
      direction: false,
      destinationOptions: {
        start: false,
        end: false,
        via: false,
      },
      showRouteTypes: false,
      showRouteOverview: false,
      showRouteDetails: false,
      routeCalculated: false,
      routeData: {},
      showRoadwork: false,
      showParking: false,
      typeOfParking: false,
      showDirectionsTutorial: false,
    }
  },
  props: {
    action: {
      default: false
    },
    params: {
      default: false,
    }
  },
  watch: {
    $route(to, from) {
      this.checkUrlParams();
    }
  },
  components: {
    DirectionsMap, DirectionsSearchBox, DirectionsBar, DirectionsInputFields, RouteTypes, RouteOverview, RouteDetails, DirectionsTutorial
  },
  beforeCreate() {
    this.$root.$emit('toggleLoadingScreen', true);
  },
  created() {
    EventBus.$on('closeRouteDetails', () => {
      this.showRouteDetails = false;
    });
    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Ruteplanlæggeren');
    if(localStorage.getItem('OdenseRundt-TutorialDirections') == 'true') {
      this.showDirectionsTutorial = true;
    }
    this.initOverlaySettings();
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus();
    this.setupFynPolygon();
    setTimeout(() => {
      this.checkUrlParams();
    }, 500);
  },
  methods: {
    initOverlaySettings() {
      //Check roadwork settings
      var roadworkSetting = localStorage.getItem('OdenseRundt-OverlayOption-Roadwork');
      (roadworkSetting == 'false') ? this.showRoadwork = false : this.showRoadwork = true;

      //Check parking setting
      var parkingSetting = localStorage.getItem('OdenseRundt-OverlayOption-Parking');
      (parkingSetting == 'false' || parkingSetting == undefined) ? this.showParking = false : this.showParking = true;
    },

    checkUrlParams() {
  		//var removeTripLayer = true;
      if(this.action == 'search') {
        this.showAddressSearch = true;
        this.direction = this.params;
        var alreadySetValue = document.getElementById(this.direction+'-point-input').value;
        document.getElementById('address-search-input').value = alreadySetValue;
        setTimeout(() => {        
          document.getElementById('address-search-input').focus();
        }, 500);
      }
      else {
        this.showAddressSearch = false;
      }
			//Address
			if(this.action == 'address') {
				var address = AWS.getFirstCoords(this.params);
        var coords = address.adgangsadresse.adgangspunkt.koordinater.reverse();
				var options = {direction: 'end', type: 'coords', name: address.adressebetegnelse, coords: {lat: parseFloat(coords[0]), lng: parseFloat(coords[1])}};
				this.$refs.directionsSearchBox.getDestinationData(options);
        this.$router.replace('/directions');
			}
			//Tag and id
      if(this.action == 'place') {
        var params = this.params.split(',');
				DataFunctions.getFeatureById(params[0], params[1]).then((data) => {
          DataFunctions.findPrimaryTag(data).then((primaryTag) => {
            /*if(this.$HelperFunctions.hasProp(105, data)) {
    					this.enterTripMode(data);
    					removeTripLayer = false;
    				}
    				else {*/
    					var options = {direction: 'end', name: data.name, type: primaryTag.name, tagId: params[0], placeId: params[1], coords: {lat: false, lng: false}};
    					this.$refs.directionsSearchBox.getDestinationData(options);
    				//}
            this.$router.replace('/directions');
          });
        });
			}
			//Coordinates
			if(this.action == 'coords') {
        var params = this.params.split(',');
				var options = {direction: 'end', type: 'coords', coords: {lat: parseFloat(params[0]), lng: parseFloat(params[1])}};
				this.$refs.directionsSearchBox.getDestinationData(options);
        this.$router.replace('/directions');
			}

  		/*if(removeTripLayer) {
  			if(this.map.map.hasLayer(this.tripLayer)) {
  				this.map.map.removeLayer(this.tripLayer);
  			}
  			if(this.map.map.hasLayer(this.tripRelatedPlacesLayer)) {
  				this.map.map.removeLayer(this.tripRelatedPlacesLayer);
  			}
  			this.inTripMode = false;
  			$('#directions-via-toggle').removeClass('visible-hidden');
  		}*/

      this.$root.$emit('toggleLoadingScreen', false);
  	},
    switcharoo() {
  		var startPointValue = document.getElementById('start-point-input').value;
  		var endPointValue = document.getElementById('end-point-input').value;
  		var startPointCoords = RoutePlanner.destinationCoords['start'];
      var endPointCoords = RoutePlanner.destinationCoords['end'];

      if(startPointCoords != false) {
  			var endOptions = {coords: {lat: startPointCoords.lat, lng: startPointCoords.lng}, type: 'coords', direction: 'end'};
  			this.setDestination(endOptions, startPointValue);
  		}
  		else {
  			document.getElementById('end-point-input').value = startPointValue;
  			RoutePlanner.destinationCoords.end = false;
  		}

      if(endPointCoords != false) {
  			var startOptions = {coords: {lat: endPointCoords.lat, lng: endPointCoords.lng}, type: 'coords', direction: 'start'};
  			this.setDestination(startOptions, endPointValue);
  		}
  		else {
        document.getElementById('start-point-input').value = endPointValue;
  			RoutePlanner.destinationCoords.start = false;
  		}

  		this.checkIfRouteCanBeCalculated();
    },

    toggleRoadwork(bool) {
      this.showRoadwork = (bool == undefined) ? !this.showRoadwork : bool;
      if(localStorage.getItem('OdenseRundt-FunctionalCookies') == 'true') {
        localStorage.setItem('OdenseRundt-OverlayOption-Roadwork', this.showRoadwork);
      }
    },

    toggleParking(bool) {
      this.showParking = (bool == undefined) ? !this.showParking : bool;
      if(localStorage.getItem('OdenseRundt-FunctionalCookies') == 'true') {
        localStorage.setItem('OdenseRundt-OverlayOption-Parking', this.showParking);
      }
    },

    toggleViaPoint() {
      if(this.showViaPoint) {
        this.showViaPoint = false;
        RoutePlanner.destinationCoords.via = false;
        this.destinationOptions['via'] = {direction: 'via', remove: true};
        document.getElementById('via-point-input').value = '';
        this.checkIfRouteCanBeCalculated();
      }
      else {
        this.showViaPoint = true;
      }
    },
    //Lookup address if only coords from URL param or select on map
    destinationSelectedOnMap(options) {
      if(options.direction == 'via') {
        this.showViaPoint = true;
      }
      this.$refs.directionsSearchBox.getDestinationData(options);
    },
  	//Add final data to interface and routeplanner class
  	setDestination(options, destinationName) {
      //console.log(options);
      this.showAddressSearch = false;

  	  if(!this.isDestinationWithinBounds(options.coords.lat, options.coords.lng)) {
  			this.onOutOfBoundsError();
  		}
  		else {
        this.destinationOptions[options.direction] = options;
        document.getElementById(options.direction+'-point-input').value = destinationName;
  			/*if(options.direction == 'end' && this.inTripMode == false) {
  				if(this.MapOverlays.showParkingOnMap == false || this.map.map.getZoom() < 15) {
  					this.showNearestParking(options);
  				}
  			}*/
        this.addToHistory(options);
			  RoutePlanner.setDestinationData(options);
  		}
      this.$router.replace('/directions');
  		this.checkIfRouteCanBeCalculated();
  	},
    //Add to history
  	addToHistory: function(options) {
  		if(localStorage.getItem('OdenseRundt-FunctionalCookies') == 'true') {
  			var currentHistory = localStorage.getItem('OdenseRundt-DestinationHistory');
			  var item;
  			if(currentHistory == null) {
  				item = [{name: options.name, coords: options.coords, type: options.type, placeId: options.placeId, tagId: options.tagId, href: options.href}];
  				localStorage.setItem('OdenseRundt-DestinationHistory', JSON.stringify(item));
  			}
  			else {
  				currentHistory = JSON.parse(currentHistory);
  				for(var i in currentHistory) {
  					if(currentHistory[i].name == options.name) {
  						delete currentHistory[i];
  					}
  				}

  				currentHistory = currentHistory.filter(function(value) { return value });
  				currentHistory.push({name: options.name, coords: options.coords, type: options.type, placeId: options.placeId, tagId: options.tagId, href: options.href});

  				if(currentHistory.length > 100){
  					currentHistory.shift();
  				}

  				localStorage.setItem('OdenseRundt-DestinationHistory', JSON.stringify(currentHistory));
  			}
  		}
  	},

    selectRouteType(routeType, routeSubType) {
      this.$root.$emit('toggleLoadingScreen', true);
  		if(routeType == 'bike') {
        this.typeOfParking = 'bike';
  		}
  		else {
  			if(routeType == 'car') {
          this.typeOfParking = 'car';
  			}
  			else {
          this.typeOfParking = false;
  			}
  		}

  		//Find selected route type and set as active
  		for(var i in RoutePlanner.routeTypes) {
  			if(i == routeType || i == routeSubType) {
  				RoutePlanner.routeTypes[i].selected = true;
  				RoutePlanner.selectedType = (routeSubType !== undefined) ? routeSubType : routeType;
  			}
  			else {
  				RoutePlanner.routeTypes[i].selected = false;
  			}
  		}
  		//console.log(RoutePlanner.routeTypes);

  		/*if(this.inTripMode) {
  			this.adjustRouteForTrip(routeType);
  		}*/
      var that = this;
  		setTimeout(function() {
  			RoutePlanner.createRoutePlan(function(routeObject) {that.routePlanReady(routeObject)});
  		}, 500);
    },
    //Check route values and make routetype box visible if route can be calculated
  	checkIfRouteCanBeCalculated() {
      this.showRouteOverview = false;
  		if(RoutePlanner.destinationCoords['start'] != false && RoutePlanner.destinationCoords['end'] != false) {
        this.showRouteTypes = true;
  			//$('.route-type-select').addClass('animated infinite headShake');
  			if(this.routeCalculated) {
  				//Reset values so that old text isnt shown
  				document.getElementById('route-type-car-text').innerHTML = 'Bil';
  				document.getElementById('route-type-bike-text').innerHTML = 'Cykel';
  				document.getElementById('route-type-pedestrian-text').innerHTML = 'Fodgænger';
          var that = this;
  				setTimeout(function() {
  					RoutePlanner.createRoutePlan(function(routeObject) {that.routePlanReady(routeObject)});
  				}, 500);
  			}
  		}
  		else {
        this.showRouteTypes = false;
  		}
  	},
    getActiveNetwork(routeObject) {
      //console.log(routeObject);
      if(routeObject.type != 'pedestrian') {
        var activeNetwork;
        for(var i in routeObject.networks) {
          if(routeObject.networks[i].active == true && routeObject.networks[i].route != "Error") {
            return routeObject.networks[i];
          }
        }
      }
      else {
        return routeObject.basicNetwork;
      }
    },
    //Callback when route is done
  	routePlanReady(routeObject) {
      //console.log(routeObject);
      //Set that route is calculated so if start/end point are edited route is recalced on change
      this.routeCalculated = true;
  		var activeRoute = this.getActiveNetwork(routeObject);
  		if(activeRoute == undefined) {
        console.log('No active route');
  			let settings = {message: 'Vi kunne ikke beregne den ønskede rute. Det skyldes måske en fejl i vores rutenetværk. Prøv igen om et par minutter. Hvis problemet fortsætter, så kontakt os på <a class="blue-text" href="mailto:odenserundt@odense.dk">OdenseRundt@odense.dk</a>'};
        EventBus.$emit('openMessageBox', settings);
        this.$root.$emit('toggleLoadingScreen', false);
  		}
  		else {
        this.trackRouteSession(routeObject);
        this.showRouteOverview = true;

  			//Check for differences between active and next network
  			this.generateListOfRoutes(routeObject);

        this.$root.$emit('toggleLoadingScreen', false);
  			//this.MapOverlays.checkLayers();
  		}
  	},

  	//Check for differences in routes and add to route period selector
  	generateListOfRoutes(routeObject) {
  		var listOfRoutes = [];
  		var activeNetwork;
  		var routeError = false;

  		//If routetype has no active networks, use basic route.
  		if(routeObject.noActiveNetwork) {
  			if(routeObject.basicNetwork.route != "Error") {
  				var options = RoutePlannerTools.createRouteOptions(routeObject.basicNetwork, routeObject);
  				options.selected = true;
  				listOfRoutes.push(options);
  			}
  			else {
  				routeError = true;
  			}
  		}
  		else {
  			for(var i in routeObject.networks) {
  				if(routeObject.networks[i].active == true && routeObject.networks[i].route != "Error") {
  					var options = RoutePlannerTools.createRouteOptions(routeObject.networks[i], routeObject);
  					options.selected = true;
  					activeNetwork = options;
  					listOfRoutes.push(options);
  					if(routeObject.networks[i].alternateRoute != false) {
  						var alternateOptions = RoutePlannerTools.createAlternateRouteOptions(routeObject.networks[i], routeObject, routeObject.networks[i].alternateRoute);
  						listOfRoutes.push(alternateOptions);
  					}
  				}
  				else if(routeObject.networks[i].activeSoon == true && routeObject.networks[i].route != "Error") {
  					//Check for route differences
  					var routesDifferent = RoutePlannerTools.checkForRouteDifferences(activeNetwork, routeObject.networks[i]);
  					if(routesDifferent) {
  						var options = RoutePlannerTools.createRouteOptions(routeObject.networks[i], routeObject);
  						listOfRoutes.push(options);

  						if(routeObject.networks[i].alternateRoute != false) {
  							var alternateOptions = RoutePlannerTools.createAlternateRouteOptions(routeObject.networks[i], routeObject, routeObject.networks[i].alternateRoute);
  							listOfRoutes.push(alternateOptions);
  						}
  					}
  				}
  			}
  		}
  		if(!routeError && listOfRoutes.length != 0) {
        this.routeData = listOfRoutes;
  		}
  		else {
  			this.errorInRoute();
  		}
  	},

    //Set specific route as active
    setRouteAsActive(id) {
      for(var i in this.routeData) {
        if(this.routeData[i] != false) {
          if(this.routeData[i].name == id) {
            this.routeData[i].selected = true;
          }
          else {
            this.routeData[i].selected = false;
          }
        }
      }
      this.$refs.directionsMap.routeCalculated();
    },

    //Check if destination is inside the bounds where we can calculate a route
  	isDestinationWithinBounds(lat, lng) {
      var inside = false;
  		var poly = this.fynPolygon;
      var x = lat, y = lng;
      for(var ii=0; ii<poly.getLatLngs().length; ii++) {
        var polyPoints = poly.getLatLngs()[ii];
        for (var i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
          var xi = polyPoints[i].lat, yi = polyPoints[i].lng;
          var xj = polyPoints[j].lat, yj = polyPoints[j].lng;

          var intersect = ((yi > y) != (yj > y))
              && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
          if (intersect) inside = !inside;
        }
      }

      return inside;
  	},
  	//Create polygon used for checking if user places marker on map outside of route calculator bounds
  	setupFynPolygon() {
  		var latLng = [];
  		var fynBounds = [
  			[10.26123046875,55.677197244655474],
  			[9.748306274414062,55.549417133165896],
  			[9.753799438476562,55.529990730233514],
  			[9.734916687011719,55.512304361552516],
  			[9.683418273925781,55.525132629742544],
  			[9.654922485351562,55.502583192205186],
  			[9.698181152343748,55.4679563415489],
  			[9.707794189453125,55.43213029816778],
  			[9.82452392578125,55.21962373322949],
  			[10.2227783203125,54.83233630197034],
  			[10.7281494140625,54.69605907758271],
  			[10.986328125,55.11608453987679],
  			[10.8380126953125,55.62644530289065],
  			[10.26123046875,55.677197244655474]
  		];

  		for(var i in fynBounds) {
  			latLng.push({
  				lat: fynBounds[i][1],
  				lng: fynBounds[i][0],
  			});
  		}

  		this.fynPolygon = L.polygon(latLng);
  	},

  	onOutOfBoundsError() {
      EventBus.$emit('openMessageBox', {message: 'Odense Rundt kan beregne ruter på Fyn og brofaste øer. Vælg venligst et punkt indenfor dette område.'});
  	},

  	errorInRoute() {
      EventBus.$emit('openMessageBox', {message: 'Ruten kunne ikke beregnes. Det skyldes måske en fejl i vores rutenetværk. Prøv igen om et par minutter. Hvis fejlen forsætter så kontakt os på OdenseRundt@odense.dk</a>'});
  	},

    trackRouteSession(routeObject) {
  		this.$HelperFunctions.trackSession('directions', 'routecalculated');

  		var type;
  		if(routeObject.basicNetwork.id == 101) {
  			type = 'car';
  		}
  		else if(routeObject.basicNetwork.id == 110) {
  			type = routeObject.routeMode == 'SETFASTEST' ? 'rec' : 'short';
  		}
  		else if(routeObject.basicNetwork.id == 119) {
  			type = 'green';
  		}
  		else if(routeObject.basicNetwork.id == 128) {
  			type = '2109';
  		}
  		else if(routeObject.basicNetwork.id == 137) {
  			type = 'walk';
  		}
  		this.$HelperFunctions.trackSession('directions', type);
  	},
  },
}
</script>

<style lang="scss" scoped>
  #directions-wrap {
    position: relative;
    height: 100%;
    width: calc(100% + 10px);
    margin-left: -5px;
    margin-right: -5px;
  }

  /*Landscape - SM*/
  @media screen and (min-width: 768px) and (max-width: 991px) {
  	#directions-wrap {
  		top: 40px;
  		height: calc(100% - 40px);
  	}
  }

  #directions-box {
    position: absolute;
    top: 0px;
    left: 0px;
    height: auto;
    width: 100%;
    z-index: 1000;
  }

  @media screen and (min-width: 768px) {
    #directions-box {
      top: 60px;
      left: 10px;
      width: 500px;
    }
  }

  /*Route differences box*/
  #route-differences-box {
  	position: relative;
  	height: auto;
  	border-top: 1px solid #dedede;
  	overflow: hidden;
  	-moz-transition: height 0.5s ease;
  	-webkit-transition: height 0.5s ease;
  	-o-transition: height 0.5s ease;
  	transition: height 0.5s ease;
  }

  .route-difference-select {
  	height: 30px;
  	width: 100%;
  	padding: 3px;
  	line-height: 24px;
  	vertical-align: middle;
  	cursor: pointer;
  }

  .route-difference-select span {
    pointer-events: none;
  }
</style>
